var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94579 2.03709H6.7903C6.21113 0.81883 4.99287 0 3.57489 0C1.59772 0 0 1.59772 0 3.57489C0 4.91298 0.758916 6.0913 1.85735 6.71041V17.495L3.35521 18.9929L4.89301 17.4551L6.41084 18.9929L7.92867 17.4551L9.4465 18.9929L10.9843 17.4551L12.5021 18.9929L13.0014 18.4936L14 17.495V6.11127L9.94579 2.03709ZM10.2454 3.75464L12.2825 5.79173H10.2454V3.75464ZM1.83738 2.43652C1.83738 2.11698 2.097 1.83738 2.43652 1.83738C2.75606 1.83738 3.03566 2.097 3.03566 2.43652C3.03566 2.77603 2.77603 3.03566 2.43652 3.03566C2.097 3.03566 1.83738 2.77603 1.83738 2.43652ZM2.33666 5.13267C2.25678 5.13267 2.15692 5.09273 2.097 5.03281C1.9572 4.89301 1.9572 4.67332 2.097 4.53352L4.51355 2.097C4.65335 1.9572 4.87304 1.9572 5.01284 2.097C5.15264 2.2368 5.15264 2.45649 5.01284 2.59629L2.59629 5.03281C2.51641 5.09273 2.43652 5.13267 2.33666 5.13267ZM5.29244 4.6933C5.29244 5.03281 5.03281 5.29244 4.6933 5.29244C4.37375 5.29244 4.09415 5.03281 4.09415 4.6933C4.09415 4.37375 4.35378 4.11412 4.6933 4.11412C5.01284 4.11412 5.29244 4.37375 5.29244 4.6933ZM13.0014 17.0556L12.5021 17.5549L10.9643 16.0371L9.4465 17.5549L7.92867 16.0371L6.39087 17.5549L4.87304 16.0371L3.33524 17.5549L2.83595 17.0556V7.0699C3.07561 7.10984 3.31526 7.14979 3.55492 7.14979C5.5321 7.14979 7.12981 5.55207 7.12981 3.57489C7.12981 3.39515 7.10984 3.21541 7.08987 3.03566H9.24679V6.7903H13.0014V17.0556Z",
    fill: "#373E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1641 13.2803H4.67334V14.2788H11.1641V13.2803Z",
    fill: "#373E51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1641 10.9844H4.67334V11.9829H11.1641V10.9844Z",
    fill: "#373E51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1641 8.70703H4.67334V9.7056H11.1641V8.70703Z",
    fill: "#373E51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionIcon);
export default __webpack_public_path__ + "static/media/commissionIcon.3c78762f3c11078116e103b3df72fcec.svg";
export { ForwardRef as ReactComponent };